import DataSlot from './DataSlot';

export default DataSlot;



// WEBPACK FOOTER //
// ./src/components/atoms/DataSlot/index.js